<template>
  <li
    :class="componentClass"
    :style="componentStyle"
  >
    <site-link :to="{ hash: hash }">
      <slot />
    </site-link>
  </li>
</template>
<script>
  export default {
    name: 'JumpToNavListItem',

    props: {
      hash: {
        type: String,
        required: true
      },
      isLast: {
        type: Boolean,
        default: false
      },
      customStyle: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      },
      componentClass() {
        return ['nav-list-item', { 'margin-bottom-lg': !this.isLast }, { 'margin-bottom-0 padding-bottom-0': this.isLast }]
      }
    }
  }
</script>
